const ɵ0 = {}, ɵ1 = {};
export class AppModule {
}
export { ɵ0, ɵ1 };
